<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import appConfig from "@/../app.config";
import sgsstResourcesAPI from "@/services/standards/sgsstResources/sgsstResourcesAPI";
import itemFormatsAPI from "@/services/itemFormats/itemFormatsAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import { dateFormat } from "@/utils/helpers/format";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import DocumentActions from "@/components/document/DocumentActions.vue";

const BUDGET_CATEGORIES = [
  { value: "humano", label: "Recurso Humano" },
  { value: "fisico_tecnologico", label: "Recurso Físico y Tecnológico" },
  { value: "emergencias", label: "Manejo de Emergencias" },
  { value: "medicina", label: "Medicina Laboral" },
  { value: "mantenimiento", label: "Mantenimiento y Prevención" },
];

export default {
  page: {
    title: "1.1.3. Asignación de Recursos para el SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "1.1.3. Asignación de Recursos para el SG SST",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "1.1.3. Asignación de Recursos para el SG SST", href: "/forms/estandares/recursos-sgsst" },
        { text: "Edición de Recursos", active: true },
      ],
      budgetCategories: BUDGET_CATEGORIES,
      loading: true,
      item: null,
      itemData: null,
      resource: {
        id: this.$route.params.id,
        city: null,
        acta_date: null,
        responsibilities: [],
        budget_items: [],
        workflow_status: "draft",
        signed_at: null,
      },
      companyID: this.$store.getters["company/getCompany"].id || null,
      company: this.$store.getters["company/getCompany"] || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
    };
  },
  computed: {
    isSigned() {
      return this.resource.workflow_status === "signed";
    },
    resourcesApi() {
      return {
        pdfUrl: (id) => sgsstResourcesAPI.pdfUrl(id),
        sign: (id, payload) => sgsstResourcesAPI.sign(id, payload),
      };
    },
    budgetSummary() {
      return BUDGET_CATEGORIES.map((c) => {
        const rows = this.resource.budget_items.filter((b) => b.category === c.value);
        const programado = rows.reduce((s, r) => s + (Number(r.programado) || 0), 0);
        const ejecutado = rows.reduce((s, r) => s + (Number(r.ejecutado) || 0), 0);
        return { label: c.label, programado, ejecutado, saldo: programado - ejecutado };
      });
    },
    budgetTotals() {
      const s = this.budgetSummary;
      return {
        programado: s.reduce((a, x) => a + x.programado, 0),
        ejecutado: s.reduce((a, x) => a + x.ejecutado, 0),
        saldo: s.reduce((a, x) => a + x.saldo, 0),
      };
    },
  },
  methods: {
    dateConvert(date) {
      return dateFormat(date);
    },
    money(v) {
      return "$" + new Intl.NumberFormat("es-CO").format(Math.round(Number(v) || 0));
    },
    getItemData() {
      ItemAPI.getItems(3).then((r) => (this.itemData = r)).catch((e) => console.log(e));
    },
    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 3).then((r) => (this.item = r || null)).catch((e) => console.log(e));
    },
    allowAccess() {
      try {
        const item = this.itemData;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (!item) return false;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) {
        return false;
      }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const enabled = this.$store.state.auth.info.permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },
    load() {
      sgsstResourcesAPI
        .get(this.$route.params.id)
        .then((res) => {
          this.resource = {
            id: res.id,
            city: res.city,
            acta_date: res.acta_date ? String(res.acta_date).substring(0, 10) : null,
            responsibilities: (res.responsibilities || []).map((r) => ({
              rol_comite: r.rol_comite, responsabilidad: r.responsabilidad, designado: r.designado, curso_licencia: r.curso_licencia, estado: r.estado,
            })),
            budget_items: (res.budget_items || res.budgetItems || []).map((b) => ({
              category: b.category, rubro: b.rubro, area: b.area, requerimiento: b.requerimiento,
              descripcion_tecnica: b.descripcion_tecnica, proveedor: b.proveedor,
              tarifa: Number(b.tarifa) || 0, cantidad: Number(b.cantidad) || 0, periodicidad: b.periodicidad,
              programado: Number(b.programado) || 0, ejecutado: Number(b.ejecutado) || 0,
            })),
            workflow_status: res.workflow_status || "draft",
            signed_at: res.signed_at,
          };
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    addRow() {
      this.resource.responsibilities.push({ rol_comite: "", responsabilidad: "", designado: "", curso_licencia: "", estado: "" });
    },
    removeRow(i) {
      this.resource.responsibilities.splice(i, 1);
    },
    addBudgetRow() {
      this.resource.budget_items.push({ category: "humano", rubro: "", area: "", requerimiento: "", descripcion_tecnica: "", proveedor: "", tarifa: 0, cantidad: 0, periodicidad: "", programado: 0, ejecutado: 0 });
    },
    removeBudgetRow(i) {
      this.resource.budget_items.splice(i, 1);
    },
    downloadFormato() {
      itemFormatsAPI.list("1.1.3").then((res) => {
        const f = ((res && res.data) || [])[0];
        if (f) window.location.href = itemFormatsAPI.url(f.bucket_key);
      }).catch((e) => console.log(e));
    },
    save() {
      if (this.isSigned) return;
      this.loading = true;
      sgsstResourcesAPI
        .update(this.$route.params.id, {
          companies_id: this.companyID,
          city: this.resource.city,
          acta_date: this.resource.acta_date,
          responsibilities: this.resource.responsibilities,
          budget_items: this.resource.budget_items,
        })
        .then(() => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 3, status: "Pendiente" })
            .then(() => {
              Swal.fire({ title: "¡Éxito!", text: "¡Se ha actualizado con éxito!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
              this.loading = false;
            })
            .catch(() => (this.loading = false));
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
          Swal.fire("Error", "No se pudo actualizar", "error");
        });
    },
    onSigned(payload) {
      this.resource.workflow_status = payload.workflow_status;
      this.resource.signed_at = payload.signed_at;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-9">
        <div v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12"><CheckModal></CheckModal></div>
                <div class="col-6 text-right m-b-0">
                  <button @click="downloadFormato" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span> Formato presupuesto SG-SST
                  </button>
                </div>
              </div>

              <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
                🔒 Esta acta ya fue firmada; los datos quedan bloqueados para edición.
              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-2">
                  <b-form-group class="col-md-6 px-2" label="Ciudad">
                    <b-form-input :disabled="isSigned" v-model="resource.city" placeholder="Ciudad"></b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha del acta">
                    <b-form-input :disabled="isSigned" type="date" v-model="resource.acta_date"></b-form-input>
                  </b-form-group>
                </div>

                <label class="font-weight-bold mt-2">1. Asignación de responsabilidades y recurso humano</label>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <thead class="table-active">
                      <tr>
                        <th style="min-width:140px">Rol / Comité</th>
                        <th style="min-width:220px">Responsabilidad Principal</th>
                        <th style="min-width:140px">Designado</th>
                        <th style="min-width:120px">Curso 50h / Licencia</th>
                        <th style="min-width:90px">Estado</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(r, i) in resource.responsibilities" :key="'r' + i">
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="r.rol_comite"></b-form-input></td>
                        <td><b-form-textarea :disabled="isSigned" rows="2" size="sm" v-model="r.responsabilidad"></b-form-textarea></td>
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="r.designado"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="r.curso_licencia"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="r.estado"></b-form-input></td>
                        <td class="text-center align-middle">
                          <button v-if="!isSigned" type="button" class="btn btn-sm btn-outline-danger" @click="removeRow(i)"><i class="mdi mdi-trash-can"></i></button>
                        </td>
                      </tr>
                      <tr v-if="!resource.responsibilities.length"><td colspan="6" class="text-center text-muted">Sin filas.</td></tr>
                    </tbody>
                  </table>
                  <button v-if="!isSigned" type="button" class="btn btn-sm btn-light" @click="addRow">+ Agregar fila</button>
                </div>

                <label class="font-weight-bold mt-3">2. Plan de compras y presupuesto detallado</label>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered" style="min-width:1150px">
                    <thead class="table-active">
                      <tr>
                        <th style="min-width:150px">Categoría</th>
                        <th>Rubro</th><th>Área</th><th>Requerimiento</th><th style="min-width:160px">Descripción técnica</th><th>Proveedor</th>
                        <th style="min-width:90px">Tarifa</th><th style="min-width:70px">Cant.</th><th>Periodic.</th>
                        <th style="min-width:100px">Programado</th><th style="min-width:100px">Ejecutado</th><th style="min-width:90px">Saldo</th><th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(b, i) in resource.budget_items" :key="'b' + i">
                        <td>
                          <select :disabled="isSigned" class="form-control form-control-sm" v-model="b.category">
                            <option v-for="c in budgetCategories" :key="c.value" :value="c.value">{{ c.label }}</option>
                          </select>
                        </td>
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="b.rubro"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="b.area"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="b.requerimiento"></b-form-input></td>
                        <td><b-form-textarea :disabled="isSigned" rows="2" size="sm" v-model="b.descripcion_tecnica"></b-form-textarea></td>
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="b.proveedor"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" type="number" v-model.number="b.tarifa"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" type="number" v-model.number="b.cantidad"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" v-model="b.periodicidad"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" type="number" v-model.number="b.programado"></b-form-input></td>
                        <td><b-form-input :disabled="isSigned" size="sm" type="number" v-model.number="b.ejecutado"></b-form-input></td>
                        <td class="text-right align-middle small">{{ money((Number(b.programado) || 0) - (Number(b.ejecutado) || 0)) }}</td>
                        <td class="text-center align-middle">
                          <button v-if="!isSigned" type="button" class="btn btn-sm btn-outline-danger" @click="removeBudgetRow(i)"><i class="mdi mdi-trash-can"></i></button>
                        </td>
                      </tr>
                      <tr v-if="!resource.budget_items.length"><td colspan="13" class="text-center text-muted">Sin ítems de presupuesto.</td></tr>
                    </tbody>
                  </table>
                  <button v-if="!isSigned" type="button" class="btn btn-sm btn-light" @click="addBudgetRow">+ Agregar ítem</button>
                </div>

                <label class="font-weight-bold mt-3">Resumen de presupuesto (auto-calculado)</label>
                <table class="table table-sm table-bordered" style="max-width:680px">
                  <thead class="table-active"><tr><th>Tipo de Recurso</th><th class="text-right">Programado</th><th class="text-right">Ejecutado</th><th class="text-right">Saldo</th></tr></thead>
                  <tbody>
                    <tr v-for="(s, i) in budgetSummary" :key="'s' + i">
                      <td>{{ s.label }}</td>
                      <td class="text-right">{{ money(s.programado) }}</td>
                      <td class="text-right">{{ money(s.ejecutado) }}</td>
                      <td class="text-right">{{ money(s.saldo) }}</td>
                    </tr>
                    <tr class="font-weight-bold">
                      <td>TOTAL</td>
                      <td class="text-right">{{ money(budgetTotals.programado) }}</td>
                      <td class="text-right">{{ money(budgetTotals.ejecutado) }}</td>
                      <td class="text-right">{{ money(budgetTotals.saldo) }}</td>
                    </tr>
                  </tbody>
                </table>

                <div class="form-group text-right m-b-0 mt-3">
                  <button :disabled="isSigned" type="submit" class="btn btn-primary">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div v-else class="text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
      </div>

      <div class="col-md-3" v-if="!loading && resource.id && companyID">
        <h6 class="text-muted small mb-1">Acta de Recursos SG-SST</h6>
        <DocumentActions
          :document-id="resource.id"
          :company-id="companyID"
          :workflow-status="resource.workflow_status || 'draft'"
          :signed-at="resource.signed_at"
          :api-service="resourcesApi"
          document-title="Acta de Asignación de Recursos SG-SST"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal { background-color: transparent !important; border: none; }
</style>
